// extracted by mini-css-extract-plugin
module.exports =  {"root":"bGPgqIn4ymoxcADqfnLl","sidebar":"AqzXPp1fGpxKkyMxUxpw"};